import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Bandeau de solde de congés. N'est rendu par le parent que si applicable
 * (non-freelance, non-impersonation, allowance > 0).
 */
export default function LeaveBalanceBanner({ leaveBalance }) {
  return (
    <div
      data-testid="leave-balance-banner"
      className={`mb-6 px-5 py-4 rounded-lg border flex flex-wrap items-center gap-4 text-sm ${
        leaveBalance.overflow > 0
          ? "bg-red-50 border-red-300 text-red-900"
          : leaveBalance.remaining <= 5
            ? "bg-amber-50 border-amber-300 text-amber-900"
            : "bg-sky-50 border-sky-200 text-sky-900"
      }`}
    >
      <span className="text-[11px] uppercase tracking-[0.2em] font-mono opacity-80">
        Leaves {leaveBalance.year}
      </span>
      <span><strong data-testid="leave-taken">{leaveBalance.taken}</strong> days taken</span>
      <span className="opacity-50">·</span>
      <span><strong data-testid="leave-remaining">{leaveBalance.remaining}</strong> days remaining</span>
      <span className="opacity-50">·</span>
      <span>Annual quota : {leaveBalance.allowance} j</span>
      {leaveBalance.overflow > 0 && (
        <span
          data-testid="leave-overflow"
          className="ml-auto inline-flex items-center gap-1 px-2 py-0.5 bg-red-700 text-white rounded text-xs font-mono uppercase"
        >
          <AlertTriangle size={12} /> Dépassement {leaveBalance.overflow} j → crédit année prochaine (max {leaveBalance.credit_allowance} j)
        </span>
      )}
    </div>
  );
}
